import React from "react";
import { useSelector } from "react-redux";
import useInstallPrompt from "./useInstallPrompt";

export default function InstallPromptBanner() {
  const { isMobileUserAgent } = useSelector((state) => state.userviewstore);
  const { showInstallPrompt, installApp, dismissPrompt } = useInstallPrompt();

  if (!showInstallPrompt || !isMobileUserAgent) return null;

  return (
    <div className="install-prompt">
      <p>Install app to your device for a better experience!</p>
      <div className="install-prompt-button-container">
        <button onClick={dismissPrompt} className="app_btn_outline_primary popup_button">
          Cancel
        </button>
        <button onClick={installApp} className="app_btn_primary popup_button">
          Install
        </button>
      </div>
    </div>
  );
}
